import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box, Tab, Card, Button, Typography, Tooltip, IconButton, Grid, TextField, FormControl, Stack, Link, Dialog, DialogTitle, DialogContent, DialogActions, CardContent, Select, InputLabel, FormControlLabel, FormGroup, Switch, Autocomplete } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import './biddingSelection.css';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { authKey, DOWNLOAD_DOCUMENT, BIDDING_TERM_ACCEPTANCE_REPORT, GET_ALLOTMENT_REQ_NUMBER_LIST, UPDATE_TRANSPORTER_STATUS_TO_BID } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { toast } from "react-toastify";
import apiClient from "../../../axios";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

function BiddingAcceptanceReport() {
    const [allotmentReqList, setAllotmentReqList] = useState([]);
    const [allotmentRequestNumber, setAllotmentRequestNumber] = useState('');
    const [biddingsAcceptedLists, setBiddingsAcceptedLists] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newActiveState, setNewActiveState] = useState(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const handleChange = (_e, newValue, reason) => {
        if (reason === "clear" || !newValue) {
            setAllotmentRequestNumber(null);
            setBiddingsAcceptedLists([]);                     // reset grid rows to empty
        } else {
            setAllotmentRequestNumber(newValue);
            getBiddingTermAcceptanceReport(newValue)
        }
    };

    const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
        loaderService.showLoader();
        return fetch(DOWNLOAD_DOCUMENT,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": documentBlobName,
                    "containerName": "pit",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                if (type === "View") {
                    const fileName = finalfileName
                    const splittedName = fileName.split('.')
                    const fileExtension = splittedName[splittedName.length - 1];
                    let fileType;
                    switch (fileExtension) {
                        case 'pdf':
                            fileType = 'application/pdf';
                            break;
                        case 'png':
                            fileType = 'image/png';
                            break;
                        case 'jpg':
                            fileType = 'image/jpeg';
                            break;
                        case 'jpeg':
                            fileType = 'image/jpeg';
                            break;
                        default:
                            fileType = 'application/octet-stream';
                    }
                    const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                    const newWindow = window.open(url, '_blank');
                    newWindow.focus();
                }
                else {
                    const a = document.createElement("a");
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = finalfileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    const columns = [
        {
            field: 'allotmentRequestNumber', headerName: 'Allotment Request Number', width: 180,
        },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        { field: 'stakeholderUrn', headerName: 'Stakeholder URN', width: 180 },
        { field: 'transporterName', headerName: 'Stakeholder Name', width: 240 },
        {
            field: 'isBidDocumentAccepted', headerName: 'Bid Document Accepted', width: 140,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else if (params.value === false) {
                    return 'No';
                }
            }
        },
        {
            field: 'acceptedOn', headerName: 'Accepted On', width: 200,
        },
        {
            field: 'bidDocumentList',
            headerName: 'Documents',
            width: 300,
            renderCell: (params) => {
                const docs = params.value || [];
                if (docs.length === 0) return "-";
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {docs.map((doc) => (
                            <Link
                                // key={index}
                                onClick={(e) => viewdownloadDocument(doc?.biddingTermsFileId, doc?.biddingTermsFileName, "Download")}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                            >
                                {doc.biddingTermsFileName}
                            </Link>
                        ))}
                    </div>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Active',
            width: 200,
            renderCell: (params) => {
                return (
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={params?.row?.isActive === 1 ? true : false} onChange={(e) => handleSwitchChange(params.row, e.target.checked)}/>}   />
                    </FormGroup>
                );
            }
        },

    ]

    useEffect(() => {
        getAllotmentReqList();
    }, []);

    const getAllotmentReqList = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_ALLOTMENT_REQ_NUMBER_LIST,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setAllotmentReqList(response.data.allotmentRequestNumberList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    const getBiddingTermAcceptanceReport = (value) => {
        loaderService.showLoader();
        apiClient
            .post(
                BIDDING_TERM_ACCEPTANCE_REPORT,
                {
                    "bidNumber": value ? value : allotmentRequestNumber
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setBiddingsAcceptedLists(response.data.bidAcceptanceReportList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const handleSwitchChange = (row, checked) => {
        setSelectedRow(row);
        setNewActiveState(checked);
        handleConfirmOpen()
        // growersList.forEach((item) => {
        //     if (row.landId === item.landId) {
        //         item.dbsFlag = e.target.checked ? "Y" : "N"
        //         item.type = "changed"
        //     }
        // })
    }

    const onConfirmTransporterStatus = (e) => {
        handleConfirmClose();
        updateTransporterBiddingStatus(e);
    }

    const updateTransporterBiddingStatus = () => {
        if (!selectedRow) return;
        const payload = {
            bidNumber: selectedRow.bidNumber,
            stakeholderUrn: selectedRow.stakeholderUrn,
            isActive: newActiveState
        };
        loaderService.showLoader();
        apiClient
            .post(
                UPDATE_TRANSPORTER_STATUS_TO_BID,
                payload,
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                toast.success(response.data.message)
                getBiddingTermAcceptanceReport();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h4" gutterBottom>
                    Bidding Acceptance Report
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} >
                            <Grid item xs={12} lg={6}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={allotmentReqList ? allotmentReqList : []}
                                    sx={{ width: '100%' }}
                                    value={allotmentRequestNumber || null}
                                    onChange={handleChange}
                                    renderInput={(params) => <TextField {...params} label="Bid Number" />}
                                    clearOnEscape
                                />
                            </Grid>
                            <Grid item xs={12} lg={12} mt={1}>
                                <Box sx={{ height: 450, width: '100%' }}>
                                    {
                                        biddingsAcceptedLists &&
                                        <DataGrid
                                            sx={{
                                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                                            }}
                                            getRowHeight={() => 'auto'}
                                            rows={biddingsAcceptedLists}
                                            columns={columns}
                                            pageSize={10}
                                            rowsPerPageOptions={[10]}
                                            components={{ Toolbar: QuickSearchToolbar }} />
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card >
            </Container >
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmTransporterStatus} onClose={handleConfirmClose} action="Update the Transporter Status to Bid" />
        </>
    )
}
export default BiddingAcceptanceReport;